/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IEspecialty } from 'app/shared/model/especialty.model';
import { IHospitalProcedure } from 'app/shared/model/hospital-procedure.model';

export interface IHospitalProcedureSpeciality {
  id?: string;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdate?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  speciality?: IEspecialty | null;
  procedure?: IHospitalProcedure | null;
  hospitalProcedure?: IHospitalProcedure | null;
}

export const defaultValue: Readonly<IHospitalProcedureSpeciality> = {
  active: false,
};
